import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { Container, Modal, Image } from 'react-bootstrap';
import axios from 'axios';
import ActivityCard from '../ActivityCard/ActivityCard';

const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

const ActivitiesFeed = ({ activities, onUsernameClick }) => {
    const [enlargedImage, setEnlargedImage] = useState(null);
    const [attachments, setAttachments] = useState({});

    const handleImageClick = useCallback((src) => {
        setEnlargedImage(src);
    }, []);

    const handleClose = useCallback(() => {
        setEnlargedImage(null);
    }, []);

    useEffect(() => {
        const fetchAttachments = async () => {
            const newAttachments = {};
            for (const activity of activities) {
                if (activity.attachments?.length > 0) {
                    for (const attachment of activity.attachments) {
                        try {
                            const response = await axios.get(attachment.url, { responseType: 'blob' });
                            newAttachments[attachment.url] = URL.createObjectURL(response.data);
                        } catch (error) {
                            console.error('Error fetching attachment:', error);
                        }
                    }
                }
            }
            setAttachments(newAttachments);
        };

        fetchAttachments();
    }, [activities]);

    const groupedActivities = useMemo(() => activities.reduce((acc, activity) => {
        const dateKey = formatDate(activity.date);
        const userKey = activity.username || 'unknown';

        if (!acc[dateKey]) {
            acc[dateKey] = {};
        }
        if (!acc[dateKey][userKey]) {
            acc[dateKey][userKey] = {
                activities: [],
                username: userKey,
                userName: activity.userGivenName,
                profilePicture: activity.profilePicture
            };
        }
        acc[dateKey][userKey].activities.push(activity);
        return acc;
    }, {}), [activities]);

    return (
        <Container>
            {Object.entries(groupedActivities).map(([date, usersActivities]) => (
                <div key={date}>
                    <h3>{date}</h3>
                    {Object.entries(usersActivities).map(([username, activity_info]) => (
                        <ActivityCard
                            key={`${date}-${username}`}
                            activity_info={activity_info}
                            onUsernameClick={onUsernameClick}
                            handleImageClick={handleImageClick}
                            attachments={attachments}
                        />
                    ))}
                </div>
            ))}
            <Modal
                show={!!enlargedImage}
                onHide={handleClose}
                centered
                animation={false}
                size="lg"
                dialogClassName="image-modal-dialog"
            >
                <Modal.Body className="modal-body-no-padding">
                    <div className="image-container">
                        {enlargedImage && (
                            <Image
                                src={enlargedImage}
                                alt="Enlarged attachment"
                                className="modal-image"
                                fluid
                            />
                        )}
                    </div>
                </Modal.Body>
            </Modal>

        </Container>
    );
};

export default ActivitiesFeed;
